<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Account Settings</h1>
            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-gear"></i>
                    <span>Account Settings</span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container">
    <div class="row" style="height:100%;">
        <div class="col-lg-4" style="height:100%;">
            <div class="panel panel-info" style="height:100%; padding-bottom:190px;">
                <div class="panel-heading">
                    <h4>
                        <i class="fa fa-refresh"></i>
                        <span>Navigation settings</span>
                    </h4>
                </div>
                <div class="panel-body" style="height:100%;">
                    <div class="input-group">
                        <label class="form-label input-group-addon">Start Page</label>
                        <select class="form-control" [(ngModel)]="startPage" (change)="setHomePage()">
                            <option value="home">Home</option>
                            <option *ngIf="hasPermission('Users')" value="user">Users</option>
                            <option *ngIf="hasPermission('Device')" value="devices">Devices</option>
                            <optgroup label="Associations" *ngIf="hasPermission('Association') || hasPermission('Assets') || hasPermission('AssetDetails')">
                                <option *ngIf="hasPermission('Association')" value="association/equipment">Equipment Associations</option>
                                <option *ngIf="hasPermission('Assets')" value="association/document">Document Associations</option>
                                <option *ngIf="hasPermission('AssetDetails')" value="association/documentdetails">Document Details</option>
                            </optgroup>
                            <optgroup label="Administration" *ngIf="hasPermission('CodeManagement') || hasPermission('Language') || hasPermission('DocumentManagement')">
                                <option *ngIf="hasPermission('CodeManagement')" value="administration/codemanagement">Code Management</option>
                                <option *ngIf="hasPermission('DocumentManagement')" value="administration/fmiproduct">Document Management</option>
                                <option *ngIf="hasPermission('Language')" value="administration/languagepack">Language Packs</option>
                                <option value="administration/reports">Reports</option>
                            </optgroup>
                            <option *ngIf="hasPermission('Annotation')" value="annotations">Annotations</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4" style="height:100%;">
            <div class="panel panel-info" style="height:100%; padding-bottom:190px;">
                <div class="panel-heading">
                    <h4>
                        <i class="fa fa-envelope"></i>
                        <span>Notification settings</span>
                    </h4>
                </div>
                <div class="panel-body" style="height:100%; overflow-y:scroll;">
                    <div class="panel-group">
                        <div class="panel panel-info" *ngFor="let group of settingGroups.Data">
                            <div class="panel-heading" style="cursor: pointer;" (click)="expand(group.Id)">
                                <h4 class="panel-title">
                                    {{ group.GroupName }}
                                </h4>
                            </div>
                            <div class="panel-collapse collapse" [class.in]="expandedGroup == group.Id">
                                <div class="list-group" style="margin:0px;">
                                    <div class="list-group-item" *ngFor="let setting of group.AccountSettings.Data">
                                        <label class="form-label">{{ setting.SettingName }}</label>
                                        <div class="pull-right" data-bind="">
                                            <input name="setting.SettingName" class="slider" type="checkbox" [attr.data-on-color]="'success'" [attr.data-off-color]="'danger'" [attr.data-on-text]="'Yes'" [attr.data-off-text]="'No'" [attr.data-label-text]="''" [(ngModel)]="setting.Enabled" (change)="toggle(setting)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4" style="height:100%;">
            <div class="panel panel-info" style="height:100%;">
                <div class="panel-heading">
                    <h4>
                        <i class="fa fa-th-large"></i>
                        <span>Account settings</span>
                    </h4>
                </div>
                <div class="panel-body" style="height:92%; overflow-y:scroll;">
                    <div class="panel-group" id="accountSecurity">
                        <div class="panel panel-info">
                            <div class="panel-heading" style="cursor: pointer;" data-toggle="collapse" data-parent="#accountSecurity" href="#password">
                                <h4 class="panel-title">
                                    Password
                                </h4>
                            </div>
                            <div id="password" class="panel-collapse collapse">
                                <div class="list-group">
                                    <div class="list-group-item">
                                        <label class="form-label">Change Password</label>
                                        <div class="pull-right">
                                            <button class="btn btn-info btn-xs" (click)="changePassword()">Change</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-info">
                            <div class="panel-heading" style="cursor: pointer;" data-toggle="collapse" data-parent="#accountSecurity" href="#securityQuestions">
                                <h4 class="panel-title">
                                    Security Questions
                                </h4>
                            </div>
                            <div id="securityQuestions" class="panel-body panel-collapse collapse">
                                <div class="list-group">
                                    <div class="list-group-item" *ngFor="let question of securityQuestions">
                                        <div class="list-group-item-heading">
                                            <label class="form-label" style="display:inline-block;">{{ question.Question }}</label>
                                        </div>
                                        <div class="list-group-item-text">
                                            <button class="btn btn-xs" [class.btn-success]="question.Answered" [class.btn-info]="!question.Answered" (click)="changeAnswer(question)"> {{ question.Answered ? 'Change Answer' : 'Answer' }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div bsModal #changePasswordModal="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="forgotModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <form (ngSubmit)="commitChangePassword()" #changePasswordForm="ngForm">
                <div class="modal-header">
                    <button type="button" class="close" aria-hidden="true" (click)="close()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Reset Password</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="input-group-addon">Old Password</label>
                                <input #oldPasswordControl="ngModel" name="oldPassword" type="password" required class="form-control" [(ngModel)]="oldPassword" [ngClass]="{ 'has-error': !oldPasswordControl.valid }" />
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="input-group-addon">New Password</label>
                                <input #newPasswordControl="ngModel" name="newPassword" type="password" required class="form-control" [(ngModel)]="newPassword" [ngClass]="{ 'has-error': !newPasswordControl.valid }" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback" [class.has-success]="newPassword == validatePassword" [class.has-error]="newPassword != validatePassword">
                                <label class="control-label input-group-addon" for="validatePassword">Verify</label>
                                <input name="validatePassword" type="password" required class="form-control" [(ngModel)]="validatePassword" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!changePasswordForm.form.valid || newPassword != validatePassword">Change Password</button>
                </div>
            </form>
        </div>
    </div>
</div>


<div bsModal #changeQuestionAnswerModal="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="forgotModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <form (ngSubmit)="commitChangeQuestionAnswer()" #changeQuestionAnswerForm="ngForm">
                <div class="modal-header">
                    <button type="button" class="close" aria-hidden="true" (click)="closeQuestionModal()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Answer Question</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group" data-bind="with: question">
                                <label class="input-group-addon">Question</label>
                                <input name="securityQuestion" type="text" disabled class="form-control" [(ngModel)]="question.Question" />
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="input-group-addon">Answer</label>
                                <input #answerControl="ngModel" name="securityQuestionAnswer" type="text" required class="form-control" [(ngModel)]="questionAnswer" [ngClass]="{ 'has-error' : !answerControl.valid }" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-warning" (click)="clearAnswer()" *ngIf="question.Answered">Clear Answer</button>
                    <button type="button" class="btn btn-default" (click)="closeQuestionModal()">Cancel</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!changeQuestionAnswerForm.form.valid">Submit Answer</button>
                </div>
            </form>
        </div>
    </div>
</div>